export default {
  props: {
    data: Object,
  },
  data () {
    return {
      Select: ['-', '-', '-', '-', '-', '-', '-'],
      NumberLength: 7,
      NumberBallRange: [49, 1],
      columns: [{
        title: '第一球',
        align: 'center',
        width: '80',
        key: 'ball',
      },
      {
        title: '第二球',
        align: 'center',
        width: '80',
        key: 'ball',
      },
      {
        title: '第三球',
        align: 'center',
        width: '80',
        key: 'ball'
      },
      {
        title: '第四球',
        align: 'center',
        width: '80',
        key: 'ball'
      },
      {
        title: '第五球',
        align: 'center',
        width: '80',
        key: 'ball'
      },
      {
        title: '第六球',
        align: 'center',
        width: '80',
        key: 'ball'
      },
      {
        title: '第七球',
        align: 'center',
        width: '80',
        key: 'ball'
      }
      ]
    }
  }
}